import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeaveTypeRoutingModule } from './leave-type-routing.module';
import { LeaveTypeComponent } from './leave-type.component';
import { LeaveTypesDetailsComponent } from './components/leave-types-details/leave-types-details.component';
import { LeaveTypesCreateComponent } from './components/leave-types-create/leave-types-create.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [LeaveTypeComponent, LeaveTypesDetailsComponent, LeaveTypesCreateComponent],
  imports: [
    CommonModule,
    LeaveTypeRoutingModule,
    SharedModule,
  ]
})
export class LeaveTypeModule { }
